import { Injectable, Type } from '@angular/core';
import { ActivatedRouteSnapshot, Data, RouterStateSnapshot } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, of, switchMap, take, tap } from 'rxjs';
import { SvcAppSettings } from '@solvace/common/settings/svc-app-settings';
import { SvcModule } from '@solvace/common/settings/enums/svc-module.enum';
import { SvcDialogService } from './svc-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class SvcDialogResolver {
  constructor(
    public _dialog: SvcDialogService,
    public _appSettings: SvcAppSettings
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MatDialogRef<any>> | Observable<any> {
    const data = route.data;
    const dialog = data.resolveDialog ? data.resolveDialog(route) : data.dialog;
    const component = (data.dialogComponent as Type<any> | undefined) ?? route.routeConfig?.component;

    if (dialog instanceof Observable) {
      return dialog.pipe(
        tap((dialog) => {
          this._openDialog(component, data, dialog);
        })
      );
    }

    this._openDialog(component, data, dialog);

    return of(true);
  }

  private _openDialog(component: Type<any>, data: Data, dialog: any) {
    const dialogRef = this._dialog.open(component, {
      ...data,
      data: dialog,
      closeOnNavigation: true,
      disableClose: data.disableClose ?? false,
      backdropClass: data.backdropClass,
      size: data.size,
    });

        dialogRef.afterClosed().pipe(
            switchMap((response) => {
              if (response?.dialogRef && 'afterClosed' in response?.dialogRef)
                return response.dialogRef.afterClosed();
              return of(response);
            }),
            tap(() => {
                const closeFunctionName = {
                    [SvcModule.Notification]: 'closeAngularNotification',
                    [SvcModule.ExternalFeatures]: 'closeAngularExternalFeatures',
                }[this._appSettings.module];

          if (closeFunctionName && (parent || top)?.window?.[closeFunctionName]) {
            ((parent || top)?.window?.[closeFunctionName] as any)();
          }
        }),
        take(1)
      )
      .subscribe();
  }
}
